import React from 'react';
import classNames from 'classnames';
import './index.less.js';

var Dot = function Dot(props) {
  var _a;
  var size = props.size;
  var dotCls = classNames((_a = {}, _a['ti-spin'] = true, _a['ti-spin-dot'] = true, _a["ti-spin-dot-".concat(size)] = true, _a));
  return /*#__PURE__*/React.createElement("div", {
    className: dotCls
  }, /*#__PURE__*/React.createElement("div", null));
};

export { Dot as default };
